import { render, staticRenderFns } from "./maintainfrom.vue?vue&type=template&id=c3bbc654&scoped=true"
import script from "./maintainfrom.vue?vue&type=script&lang=js"
export * from "./maintainfrom.vue?vue&type=script&lang=js"
import style0 from "./maintainfrom.vue?vue&type=style&index=0&id=c3bbc654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bbc654",
  null
  
)

export default component.exports